<template>
  <div class="OrderManageCreate-root">
    <span v-if="odrNo && !oneMoreOrder" class="odr-txt">订单号 {{ odrNo }}</span>
    <a-form-model
        ref="orderForm"
        class="order-manage-create-page"
        :model="form"
        layout="horizontal"
        :rules="rules"
        :label-col="{span: 6}"
        :wrapper-col="{span: 18}"
    >
      <a-spin :spinning="loading.onSubmit">
        <a-space direction="vertical">
          <div v-if="!offContract" class="contrat-container">
            <div class="carrier_cut">
              <div v-if="isEnterprise" class="carrier">
                <img src="@/assets/img/icon_fuwushang.png" alt="">
                <cutCarrier></cutCarrier>
              </div>
              <div v-if="!hideByRuleFields.includes(RULE_FIELD.EMAIL_PRODUCT_CODE)&& !systemAutoDetail[RULE_FIELD.EMAIL_PRODUCT_CODE]" class="projectTitle">
                <div class="item-line"/>
                <img src="@/assets/img/icon/icon_hetong.png" alt="">
                <span class="subtitle">合同条款</span>
                <span v-if="!isEditPage && !selectdisabled" class="contractTitleName replaceContract"
                      @click="replaceContract">{{ systemAutoDetail[RULE_FIELD.EMAIL_PRODUCT_CODE]?systemAutoDetail[RULE_FIELD.EMAIL_PRODUCT_CODE].contractName : form.contractName }} - {{ systemAutoDetail[RULE_FIELD.EMAIL_PRODUCT_CODE]?systemAutoDetail[RULE_FIELD.EMAIL_PRODUCT_CODE].contractTermName : form.contractTermName }}</span>
                <!-- <span  class="replaceContract" >更换合同条款</span> -->
              </div>
            </div>
            <div v-if="lineTips" class="specialCarTips">
              <a-icon type="exclamation-circle"/>
              目的地{{ lineIipsName }}与起始地相同，请确认
              <a-icon type="close" @click="lineTips=false"/>
            </div>
          </div>
          <div class="block-container">
            <block-title v-if="!hideByRuleFields.includes(RULE_FIELD.EMAIL_PROJECT_CONDITION) && !systemAutoDetail[RULE_FIELD.EMAIL_PROJECT_CONDITION]" title="项目">
              <div class="content">
                <a-form-model-item
                    :colon="false"
                    :label="systemAutoDetail[RULE_FIELD.EMAIL_PROJECT_CONDITION]?false:'运营项目'"
                    prop="projectId"
                    :label-col="{span: 2}"
                    :wrapper-col="{span: 12}"
                >
                  <template v-if="systemAutoDetail[RULE_FIELD.EMAIL_PROJECT_CONDITION]">
                    <div style="padding-left: 24px">
                      {{systemAutoDetail[RULE_FIELD.EMAIL_PROJECT_CONDITION].projectName}}
                    </div>
                  </template>
                  <template v-if="customerFields[RULE_FIELD.EMAIL_PROJECT_CONDITION] && fetchOrganization">
                    <order-select v-model="form.projectId" :list="projectList" :edit="isEditPage || oneMoreOrder" @checkedList="checkedList"
                                  @onSearch="onSearchProject"/>
                    <div v-if="!projectALLData.length">
                      暂无运营项目，请联系管理员创建
<!--                      <a-button style="padding: 0" type="link" @click="toProject">创建运营项目</a-button>-->
                    </div>
                  </template>

                </a-form-model-item>
              </div>
            </block-title>
            <template v-if="!hideByRuleFields.includes(RULE_FIELD.EMAIL_CAR_TYPE)">
              <block-title v-if="systemAutoDetail[RULE_FIELD.EMAIL_CAR_TYPE]" title="车型">
                <div class="content" style="margin-top: 20px;padding-left: 24px">
                  {{systemAutoDetail[RULE_FIELD.EMAIL_CAR_TYPE].carTypeName}}
                </div>
              </block-title>
              <div
                  v-if="!systemAutoDetail[RULE_FIELD.EMAIL_CAR_TYPE]"
                  class="carBottom">
                <div class="projectTitle">
                  <span>车型选择</span>
                </div>
                <car-type v-if="form.carNorms" v-model="form.carLength" class="" :list="carTypeList"
                          :car-norms="form.carNorms" @checkedList="changeCarType"></car-type>
                <div
                    class="car-specifications"
                >
                  <span>车型规格</span>
                  <a-radio-group
                      v-if="form.carLength"
                      v-model="form.carNorms"
                      class="specifications-radio"
                      @change="changeCar"
                  >
                    <a-radio v-for="cartype in filertype" :key="cartype.id" :value="cartype.carSettingName">
                      {{ cartype.carSettingName }}
                    </a-radio>
                  </a-radio-group>
                </div>
              </div>
            </template>

            <block-title v-if="!hideByRuleFields.includes(RULE_FIELD.EMAIL_LINE_REMARK)" title="是否按线路下单">
              <div class="content">
                <div class="radioBox">
                  <a-radio-group v-model="form.isLine" class="order-radio"
                                 @change="isLineChange">
                    <a-radio :value="true" :class="form.isLine === true ? 'radioStyle' : ''">
                      是
                    </a-radio>
                    <a-radio :value="false" :class="form.isLine === false ? 'radioStyle' : ''">
                      否
                    </a-radio>
                    <div v-if="form.isLine" class="siteBox">
                      <select-dom v-model="form.lineId" :list="lineList" :edit="true"
                                  :tips="true" @checkedList="changeLine" @onSearch="onSearchLine"/>
                    </div>
                    <div v-if="!form.isLine" class="siteBox">
                      <a-input v-model="form.lineRemark" placeholder="请填入线路标识" />
                    </div>
                  </a-radio-group>
                </div>
              </div>
            </block-title>
            <!-- 多装多卸 -->
            <div v-if="isPretend">
              <div v-for="(startStation, i) in form.pretendStation" :key="i">
                <block-title
                    class="origin-station"
                    :title="`发货地信息${form.pretendStation.length > 1 ? i + 1 : ''}`"
                    icon-title="发"
                >
                        <span v-if="form.pretendStation.length !== 1" slot="icon-right" class="deleteStyle"
                              @click="onDeleteStartStation(i)">
                            <a-icon type="delete"/>删除
                        </span>
                  <StartStation
                      v-model="form.pretendStation[i]"
                      :rule-station="systemAutoDetail[RULE_FIELD.START_STATION]"
                      :rule-time="systemAutoDetail[RULE_FIELD.START_TIME]"
                      :disabled="sameGroup"
                      :prop-prefix="`pretendStation.${i}`"
                      :is-line="form.isLine"
                      :is-pretend="isPretend"
                      :pretend-station="form.pretendStation"
                      subtitle="发货地信息"
                      @changeDetil="filterChangeDetil"
                  />
                </block-title>
              </div>
            </div>
            <block-title
                v-else
                class="origin-station"
                title="发货地信息"
                icon-title="发"
            >
              <StartStation
                  v-model="form.startStation"
                  :disabled="sameGroup"
                  subtitle="发货地信息"
              />
            </block-title>
          </div>
          <div v-if="addParentd && !systemAutoDetail[RULE_FIELD.START_STATION] || form.isLine" class="station-add-wrapper">
            <div class="add-wrapper-batch" @click="batchAddStartStation">
              <img class="icon-batch-address" src="https://prod-ylzapp-public.oss-cn-zhangjiakou.aliyuncs.com/frontend/shipper-admin/images/icon_address_batch.png">
              地址库批量添加
            </div>
            <div class="station-add">
              <a-button
                  block
                  type="link"
                  @click="onAddStartStation"
              >
                <a-icon type="plus"/>
                添加发货地
              </a-button>
            </div>
          </div>
<!--          <div v-if="addParentd && !systemAutoDetail[RULE_FIELD.START_STATION]" class="station-add startAdd">-->
<!--            <a-button-->
<!--                block-->
<!--                type="link"-->
<!--                @click="onAddStartStation"-->
<!--            >-->
<!--              <a-icon type="plus"/>-->
<!--              添加发货地-->
<!--            </a-button>-->
<!--          </div>-->
          <div
              v-for="(endStation, endStationIndex) in form.endStation"
              :key="endStationIndex"
              class="block-container"
          >
            <block-title
                class="destination"
                :title="`收货地信息${endStationIndex+1}`"
                icon-title="收"
            >
                <span v-if="form.endStation.length !== 1" slot="icon-right" class="deleteStyle"
                      @click="onDeleteEndStation(endStationIndex, endStation)">
                    <a-icon type="delete"/>删除
                </span>
              <EndStation
                  v-model="form.endStation[endStationIndex]"
                  :show-add-button="form.endStation.length < 10"
                  :show-delete-button="form.endStation.length !== 1"
                  :prop-prefix="`endStation.${endStationIndex}`"
                  :subtitle="form.endStation.length === 1 ? '收货地信息' : `收货地信息${endStationIndex + 1}`"
                  :lineorder="form.isLine"
                  :rule-station="systemAutoDetail[RULE_FIELD.END_STATION]"
                  :rule-time="systemAutoDetail[RULE_FIELD.END_TIME]"
                  :disabled="createDisabled()"
                  :mileage="filterCode(elementsCode.MILEAGE)"
                  :end-station-index="endStationIndex === form.endStation.length - 1"
                  :end-station-list="form.endStation"
                  :is-pretend="isPretend"
                  @changeDetil="changeStation"
                  @delete="onDeleteEndStation(endStationIndex, endStation)">
                <GoodsInfo
                    v-if="goodsFlag"
                    v-model="endStation.stationGoodsList"
                    :rule-goods="systemAutoDetail[RULE_FIELD.SKU_INFO]"
                    :rule-time="systemAutoDetail[RULE_FIELD.START_TIME]"
                    :title="'货品信息'"
                    :order-goods-type="endStation.orderGoodsType"
                    :prop-prefix="`endStation.${endStationIndex}.stationGoodsList`"
                    :is-pretend="isPretend"
                    :pretend-station="form.pretendStation"
                    :rule-start-station="systemAutoDetail[RULE_FIELD.START_STATION]"
                    :end-station="form.endStation[endStationIndex]"
                    :is-edit-page="isEditPage"
                    :start-num="startNum"
                    @orderGoodsTypeChange="(value) => { orderGoodsTypeChange(value, endStation, endStationIndex) }"
                    @afreshVali="handleAfreshVali"
                />
              </EndStation>
            </block-title>
          </div>
          <div class="station-add-wrapper">
            <div class="add-wrapper-batch" @click="batchAddEndStation">
              <img class="icon-batch-address" src="https://prod-ylzapp-public.oss-cn-zhangjiakou.aliyuncs.com/frontend/shipper-admin/images/icon_address_batch.png">
              地址库批量添加
            </div>
            <div v-if="addEnd && !systemAutoDetail[RULE_FIELD.END_STATION]" class="station-add">
              <a-button
                  v-if="form.endStation.length < 10 && !form.isLine"
                  block
                  type="link"
                  @click="onAddEndStation"
              >
                <a-icon type="plus"/>
                添加目的地
              </a-button>
            </div>
          </div>
          <div class="block-container other-info">
            <block-title title="其他信息">
              <a-row>
                <a-col v-if="isParentMark()" :md="6" :sm="24">
                  <a-form-model-item
                      :colon="false"
                      :label-col="{span: 6}"
                      :wrapper-col="{span: 17}"
                  >
                  <template #label>
                   <span class="zimu_table">
                      <span>子母单标识</span>
                      <el-tooltip
                        content="非必填，相同子母单标识的订单，将合并计费"
                        placement="top"
                      >
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </span>
                  </template>
                     <a-select
                      v-model="form.bdstNumber"
                      show-search
                      allow-clear
                      :options="orderMarkList"
                      placeholder="选择子母单标识"
                    >
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="filterCode(elementsCode.TRANSPORTTYPE)" :md="6" :sm="24">
                  <a-form-model-item
                      label="运输类型"
                      :colon="false"
                      prop="transportType"
                      :label-col="{span: 6}"
                      :wrapper-col="{span: 17}"
                  >
                    <a-radio-group v-model="form.transportType" class="order-radio" @change="transtorpChange">
                      <a-radio :value="TransportType.BREAK_BULK"
                               :class="form.transportType === TransportType.BREAK_BULK ? 'radioStyle' : ''">
                        零担
                      </a-radio>
                      <a-radio :value="TransportType.TRUCKLOAD"
                               :class="form.transportType === TransportType.TRUCKLOAD ? 'radioStyle' : ''">
                        整车
                      </a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="isShowCustomeField(ORDER_CUSTOME_FIELDS.needPickUp)&&form.transportType === TransportType.BREAK_BULK" :md="6" :sm="24">
                  <a-form-model-item
                      label="是否提货"
                      :colon="false"
                      :label-col="{span: 6}"
                      :wrapper-col="{span: 17}"
                  >
                    <a-radio-group v-model="form.needPickUp" class="order-radio">
                      <a-radio :value="true" :class="form.needPickUp === true ? 'radioStyle' : ''">
                        是
                      </a-radio>
                      <a-radio :value="false" :class="form.needPickUp === false ? 'radioStyle' : ''">
                        否
                      </a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="isShowCustomeField(ORDER_CUSTOME_FIELDS.needDelivery)&&form.transportType === TransportType.BREAK_BULK" :md="6" :sm="24">
                  <a-form-model-item
                      label="是否配送"
                      :colon="false"
                      :label-col="{span: 6}"
                      :wrapper-col="{span: 17}"
                  >
                    <a-radio-group v-model="form.needDelivery" class="order-radio">
                      <a-radio :value="true" :class="form.needDelivery === true ? 'radioStyle' : ''">
                        是
                      </a-radio>
                      <a-radio :value="false" :class="form.needDelivery === false ? 'radioStyle' : ''">
                        否
                      </a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="isShowCustomeField(ORDER_CUSTOME_FIELDS.mileageKm)" :md="6" :sm="24">
                  <a-form-model-item
                      label="预估里程"
                      :colon="false"
                      prop="mileageKm"
                      :label-col="{span: 6}"
                      :wrapper-col="{span: 17}"
                  >
                    <a-input-number
                        v-model="form.mileageKm"
                        placeholder="请输入预估里程"
                        suffix="KM"
                        class="orderNumStyle"
                        :max="5000"
                        :min="0"
                        :formatter="limitDecimals"
                        :parser="limitDecimals"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col v-if="isShowCustomeField(ORDER_CUSTOME_FIELDS.crmNumber)" :md="6" :sm="24">
                  <a-form-model-item
                      label="外部订单号"
                      :colon="false"
                      :label-col="{span: 6}"
                      :wrapper-col="{span: 17}"
                  >
                    <a-input v-model="form.crmNumber" class="orderNumStyle" placeholder="请输入外部订单号"/>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="filterCode(elementsCode.ORDERLABEL)" :md="6" :sm="24">
                  <a-form-model-item
                      prop="orderLabel"
                      label="销售渠道"
                      :colon="false"
                      :label-col="{span: 6}"
                      :wrapper-col="{span: 17}"
                  >
                    <a-input v-model="form.orderLabel" :max-length="30" class="orderNumStyle" placeholder="请输入销售渠道"/>
                  </a-form-model-item>
                </a-col>
                <a-col :md="24" :sm="24">
                  <a-form-model-item
                      label="备注"
                      :colon="false"
                      :label-col="{span: 1}"
                      :wrapper-col="{span: 17}"
                  >
                    <a-input
                        v-model="form.remark"
                        :max-length="100"
                        :auto-size="{ minRows: 3, maxRows: 3 }"
                        class="remark-input"
                        placeholder="请输入，最多不超100字"
                        type="textarea"/>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </block-title>
          </div>
        </a-space>
      </a-spin>
    </a-form-model>
    <!-- 选择合同及条款 -->
    <select-contract
        v-if="!offContract"
        ref="SelectContract"
        :contract-list="contractList"
        :default-contract-code="form.contractCode"
        :default-term-code="form.contractTermCode"
        @success="successContract"
    />
    <selectAddressDialog ref="selectAddressDialog" :station-type="batchAddType" :is-standard='true' @onBatchSelectAddress="handleAdressFromSelectorChange"/>
    <fix-bottom class="create-btns">
      <template slot="button">
        <a-button v-track-click="{trackName: '取消下单'}" @click="closeOrder">
          取消
        </a-button>
        <a-button v-track-click="{ trackName: isEditPage ? '编辑订单' : '提交订单' }"
                  v-auth="$_ButtonPermission.ORDER_PLACEORDER" class="margin-left" type="primary" :loading="upLoading"
                  @click="onSubmit">
          {{ isEditPage ? '保存' : '提交订单' }}
        </a-button>
      </template>
    </fix-bottom>
    <!-- 多装多卸未选择的起始地 -->
    <a-modal
        title="发货地信息为空提醒"
        :visible="noPretedSelect"
        @ok="submitPretend"
        @cancel="closePretend"
    >
      <p v-for="item in noSelect" :key="item.address" class="noPreteStyle">{{ item.address }}</p>
      <span class="noPreteStyle">-发货地未关联货品</span>
      <span>，你还要继续吗？</span>
    </a-modal>
    <settlementModes ref="settlementModes" />
  </div>
</template>

<script>
import moment from 'moment';
import loadingMixin from '@thales/loading'
import { mapState,mapGetters } from 'vuex'
import FormValidator from '@/constants/formValidator'
import FixBottom from '@/components/fix-bottom/index.vue';

// import BlockPanel from '@/components/panel/BlockPanel.vue'
import {TransportType, StationTypes} from '@/pages/orderManage/constant'
import SelectDom from '@/components/select/SelectDom'
import OrderSelect from '@/components/select/OrderSelect.vue'
import setScrollTop from '@/utils/scroll'
// import sortNumber from '@/utils/sortNumber'
import BlockTitle from '@/components/panel/BlockTitle.vue'
import {ORDER_CUSTOME_FIELDS} from '@/constants/ruleConfig'
import { RULE_ACTION , RULE_FIELD } from "@/pages/orderManage/pureOrderManageCreate/constants";
import selectAddressDialog from "@/pages/orderManage/components/SelectAddressDialog.vue";
import {scrollToTarget} from "@/utils/util";
import settlementModes from '@/components/settlementModes/index.vue'
import CarType from '../StandardOrderManageCreate/components/CarType.vue'
import {
  // createOrder,
  createOrderByRule,
  featchOrderDetailUnify,
  updateOrder,
  fetchProject,
  getCarLine,
  getStations,
  // getContractEntry,
  getContract,
  // createManyStandardOrder,
  updateStandardEditUnify,
  getNoRYCarLine,
  getStandCarType,
  parentMarkList
} from '../api.js'

import GoodsInfo from './components/GoodsInfo'
import StartStation from './components/StartStation'
import EndStation from './components/EndStation'
import SelectContract from '../components/SelectContract'
import cutCarrier from '../components/cutCarrier.vue'


const tationTypeCode = {
  start: 0, // 起始地
  end: 1, // 目的地
  startEnd: 2 // 起始地加目的地
}

const GOODS = {
  skuId: '',
  skuName: '',
  number: '',
  weight: '',
  volume: '',
  skuUnit: '',
  temperatureZone: '',
  goodsValue: '',
  lowtemp: '',
  hightemp: '',
  shipment: '',
  startStationAddress: '',
}

const END_STATION = {
  stationId: '',
  contactName: '',
  contactPhone: '',
  provinceName: '',
  cityName: '',
  countyName: '',
  address: '',
  expectTime: null,
  // crmNumber: '',
  defaultAddress: [],
  orderGoodsType: 1,
  mileageKm: ''
}

const START_STATION = {
  stationId: '',
  contactName: '',
  contactPhone: '',
  expectTime: null,
  provinceName: '',
  cityName: '',
  countyName: '',
  address: '',
  defaultAddress: [],
}

const elementsCode = {
  MILEAGE: 'mileage',  // 里程
  CARTYPE: 'carType',  // 车型
  TRANSPORTTYPE: 'transportType',  // 运输类型
  LINE: 'LINE',   // 线路
  ORDERLABEL: 'orderLabel', // 销售渠道
}
const CANCELED = 'CANCELED'
const odrChannel = 15

export default {
  name: 'PureOrderManageCreate',
  components: {
    GoodsInfo,
    // BlockPanel,
    StartStation,
    EndStation,
    SelectDom,
    SelectContract,
    FixBottom,
    BlockTitle,
    cutCarrier,
    OrderSelect,
    CarType,
    selectAddressDialog,
    settlementModes,
  },
  mixins: [loadingMixin],
  props:{
    emailRules:{
      type:Array
    }
  },
  inject: ['order'],
  data() {
    return {
      RULE_ACTION,
      RULE_FIELD,
      bottom: 0,
      loading: {
        onSubmit: false
      },
      FormValidator,
      ORDER_CUSTOME_FIELDS,
      isEditPage: false,
      oneMoreOrder: false,
      odrNo: '',
      TransportType,
      startTime: null, // 编辑时需要保存返回的起始地取货时间
      contractList: [], // 合同列表
      form: {
        projectId: '',
        projectName: '',
        parentId: '',
        startStation: {
          stationId: '',
          contactName: '',
          contactPhone: '',
          expectTime: null,
          provinceName: '',
          cityName: '',
          countyName: '',
          address: '',
          defaultAddress: []
        },
        endStation: [
          {
            ...END_STATION,
            // stationGoodsList: [{ ...GOODS }]
            stationGoodsList: [{...GOODS}]
          }
        ],
        pretendStation: [{...START_STATION}],
        transportType: TransportType.BREAK_BULK,
        needShelves: false,
        needHandling: false,
        remark: '',
        contractCode: '', // 合同id
        contractName: '',
        contractTermCode: '',    // 条款id
        contractTermName: '',
        isLine: false,
        lineName: '',
        lineId: '',
        mileageKm: '',
        needPickUp: false,
        needDelivery: false,
        carLength: '',
        carTypeId: '',
        carTypeName: '',
        carNorms: '',
        lineRemark: '',
        crmNumber: '',
      },
      rules: {
        startStation: {
          expectTime: [
            {required: true, message: '请选择需要取货时间', trigger: 'change'},
          ],
        },
        // projectId: [
        //   {required: true, message: '请选择项目', trigger: 'change'},
        // ],
        // transportType: [
        //   {required: true, message: '请选择运输类型', trigger: 'change'},
        // ],
        // carTypeId: [
        //   {required: true, message: '请选择车型', trigger: 'change'},
        // ],
        // mileageKm: [
        //   {required: true, message: '请输入预估里程', trigger: 'blur'},
        // ],
        orderLabel: [
          {required: true, message: '请输入销售渠道', trigger: 'blur'}
        ],
      },
      endStations: [],
      projectList: [],
      accountData: {},
      selectAll: true,
      projectALLData: [],
      lineList: [],
      carTypeList: [],
      allCarTypeList: [],
      sameGroup: false, // 是否同组
      productList: [],
      elementsCode,
      selectdisabled: false,
      offContract: false,
      upLoading: false,
      carTypeflag: false,
      lineTips: false,
      lineIipsName: '',
      lineDisbled: false,
      isPretend: true, // 是否多装多卸白名单
      goodsFlag: true,
      noPretedSelect: false,
      noSelect: [],
      changeDetil: '',
      startNum: [],
      isEnterprise: false,
      fetchOrganization: false,
      rulesMap: {}, // 规则map
      systemAutoDetail:{}, // 规则字段为系统自动填充字段的详情展示
      customerFields:{}, // 规则字段为客户填写自动填充字段的详情展示
      hideByRuleFields:[], // 根据规则不用填写的字段
      batchAddType:StationTypes.RECEIVING,
      orderMarkList:[], // 子母单列表
    }
  },
  computed: {
    ...mapState('orderRules', ['orderRules']),
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
    addParentd() {
      return !this.form.isLine && this.form.pretendStation.length < 10 && (this.form.pretendStation.length < 10 || this.form.pretendStation.length !== 1) && !(this.form.carCityType === 1 && !this.filterstand().includes(this.standardType.CP004))
    },
    addEnd() {
      return (this.form.endStation.length < 10 || this.form.endStation.length !== 1) && !this.form.isLine
    },
    isSameContractTermCode(){
      // if(this.hideByRuleFields.includes(RULE_FIELD.EMAIL_PRODUCT_CODE)) { // 合同条款
      //   return true
      // }
      // 查询项目绑定合同是否是当前选择合同
      return (e,data)=>{
          if(e.operationContractResp&&e.operationContractResp.contractCode){
            return e.operationContractResp.contractCode===data.contractCode&&e.operationResp.termCode===data.contractTermCode || this.hideByRuleFields.includes(RULE_FIELD.EMAIL_PRODUCT_CODE)
          }
        return true
      }
    },
    filertype(){
      if(this.carTypeList[this.form.carLength]) {
        return this.carTypeList[this.form.carLength]
      }
      const selected = Object.values(this.carTypeList).flat()?.find((e) => {
        return e.id === this.form.carTypeId
      })
      if(selected) {
        return  this.carTypeList[selected.carLength.toFixed(2)]
      }
      return ''
    },
  },
  watch: {
    "form.startStation.contactName": function () {
      this.lineTips = false
    },
    "form.startStation.contactPhone": function () {
      this.lineTips = false
    },
    "form.pretendStation": function (val) {
      // 多装多卸起始地改变后 目的地选择的起始地要清空
      const address = val.map((e) => {
        return e.address
      })
      this.form.endStation.forEach((end, i) => {
        end.stationGoodsList.forEach((goods, n) => {
          if (!address.includes(goods.shipment)) {
            if (this.changeDetil !== '') {
              this.form.endStation[i].stationGoodsList[n].shipment = this.changeDetil.address
              this.form.endStation[i].stationGoodsList[n].startStationAddress = `${this.changeDetil.province}${this.changeDetil.city}${this.changeDetil.county}${this.changeDetil.address}`
            } else {
              this.form.endStation[i].stationGoodsList[n].shipment = ''
              this.form.endStation[i].stationGoodsList[n].startStationAddress = ''
            }
            this.form.endStation[i].stationGoodsList[n].orderNo = null
            if (!this.startNum.includes(this.form.endStation[i].stationGoodsList[n].shipment)) {
              this.form.endStation[i].stationGoodsList[n].orderNo = null
            }
          }
        })
      })
      this.goodsFlag = false
      this.$nextTick(() => {
        this.goodsFlag = true
      })
    },
    "emailRules" :function () {
      this.createEmailRules()
    }
  },
  created() {
    // this.tabsChange();
    this.createEmailRules()
    // this.offContract = this.$route.query.offContract || false
    const {customerId, creditCode} = this.$store.state.user
    this.isEnterprise = !!creditCode
    if (!creditCode) {
      this.accountData = JSON.parse(localStorage.getItem('accountData'));
      this.form.parentId = this.accountData.id
    }
    this.getOrganization()
    this.getCarLine()
    this.getCarType()
    if (customerId) {
      // 获取合同列表
      this.getContractList();
    }
    this.init()
    this.selectdisabled = this.$route.query.disabled
    if(!this.systemAutoDetail[RULE_FIELD.EMAIL_CAR_TYPE]) { //
        this.rules = {
          ...this.rules,
          carTypeId: [
            {required: true, message: '请选择车型', trigger: 'change'},
          ],
        }
    }
    if(this.isParentMark()){
      this.getParentMarkList()
    }
    // if(this.order.isProjectControl) {
    //   this.rules = {
    //     ...this.rules,
    //     projectId: [
    //       {required: true, message: '请选择项目', trigger: 'change'},
    //     ]
    //   }
    // }
  },
  beforeRouteEnter(to, from, next) {
    setScrollTop()
    next(mv => {
      const authority = mv.$store.state.user.companyType
      if (!authority) {
        mv.$router.go(-1)
      }
    })
  },
  beforeDestroy() {
  },
  methods: {
    async getParentMarkList() {
      // 子母单列表获取
      const {tenantId, customerCode} = this.$store.state.user
      const res = await parentMarkList({
        customerCode,
        tenantId,
        statuses: ['ENABLE'],
      });
      if(res&&res.length){
        this.orderMarkList = res.map(item=>({value:item.code,label:item.code}))
      }else{
        this.orderMarkList = [];
      }
    },
    /**
     * 客户填写
     * 回填默认值，发货地、发货时间、收货地，收货时间、货品信息、车型、项目
     */
    initFormData(){
      // 发货地回填、发货地时间
      const preStartStation = this.customerFields[RULE_FIELD.START_STATION]
      const preStartTime = this.customerFields[RULE_FIELD.START_TIME]
      if(preStartStation || preStartTime) {
        const startStations = preStartStation?.ext || {};
        const pretendStation =  [{
          stationId: startStations?.sourceStationId || startStations.stationId,
          stationCode: startStations.stationCode,
          contactName: startStations.contacts || '',
          contactPhone: startStations.telPhone || '',
          expectTime: preStartTime && preStartTime?.day && preStartTime?.minute ?(moment().minute(preStartTime.minute).hour(preStartTime.hour).add(preStartTime.day, 'days').format('YYYY-MM-DD HH:mm')):'',
          // expectTimeLeft:[moment(startStations.startTime).format('HH:mm:ss')],
          provinceName: startStations.provinceName,
          cityName: startStations.cityName,
          countyName: startStations.countyName,
          provinceCode: startStations.provinceCode,
          cityCode: startStations.cityCode,
          countyCode: startStations.countyCode,
          address: startStations.address,
          stationAddress: startStations.address,
          stationContact: startStations.contacts || '',
          stationContactPhone: startStations.telPhone || '',
          stationFullAddress: startStations.provinceName+startStations.cityName+startStations.countyName+startStations.address,
          lat: startStations.latitude,
          lon: startStations.longitude
        }]
        this.$set(this.form,'pretendStation', pretendStation)
      }

      // 收货地回填、收货地时间、收货地货品
      const preEndStation = this.customerFields[RULE_FIELD.END_STATION]
      const preEndTime = this.customerFields[RULE_FIELD.END_TIME]
      const preSkuInfo = this.customerFields[RULE_FIELD.SKU_INFO]
      if(preEndStation || preEndTime || preSkuInfo) {
        const station = preEndStation?.ext || {}
        const endStation = [
          {
            id: station.id,
            stationId: station.stationId,
            stationCode: station.stationCode,
            contactName: station.contacts||'',
            contactPhone: station.telPhone||'',
            provinceName: station.provinceName,
            cityName: station.cityName,
            countyName: station.countyName,
            address: station.address,
            stationAddress: station.address,
            stationContact: station.contacts || '',
            stationContactPhone: station.telPhone || '',
            stationFullAddress: station.provinceName+station.cityName+station.countyName+station.address,
            expectTime: preEndTime && preEndTime?.day && preEndTime?.minute?(moment().minute(preEndTime.minute).hour(preEndTime.hour).add(preEndTime.day, 'days').format('YYYY-MM-DD HH:mm')):'',
            // expectTimeLeft:[moment(station[0].reachTime).format('HH:mm:ss')],
            // crmNumber: res.crmNumber,
            // mileageKm: res.mileageKm ? res.mileageKm : null,
            mileageKm: '',
            provinceCode: station.provinceCode,
            cityCode: station.cityCode,
            countyCode: station.countyCode,
            orderGoodsType: preSkuInfo?.skuId?0:1, // 客户填写选了默认货品才切换到明细tab
            lat: station.latitude,
            lon: station.longitude,
            stationGoodsList: preSkuInfo?.skuId?[
              {
                skuId: preSkuInfo.skuId,
                skuCode: preSkuInfo.skuCode,
                skuName: preSkuInfo.skuName,
                weight: preSkuInfo.totalWeight,
                volume: preSkuInfo.totalVol,
                number: preSkuInfo.totalSum,
                // skuNorms: `${goods.skuNorms}/${ext?.goodsUnit}`,
                temperatureZone: preSkuInfo.temp,
              }
            ]:[]
          }
        ]
        this.$set(this.form,'endStation', endStation)
      }

      // 车型回填
      const preCar = this.customerFields[RULE_FIELD.EMAIL_CAR_TYPE]
      const carSetting = preCar?.ext
      if(carSetting && preCar?.carTypeId) {
        let cartext = preCar.carTypeName ? parseFloat(preCar.carTypeName) : ''
        cartext = cartext ? cartext.toFixed(2) : preCar.carTypeName
        const carObj = {
          carTypeName:preCar?.carTypeName,
          carLength:cartext,
          carNorms:preCar?.carTypeName,
          carTypeId:preCar?.carTypeId,
        }
        Object.assign(this.form, carObj)
      }

      // 项目回填
      const preProject = this.customerFields[RULE_FIELD.EMAIL_PROJECT_CONDITION]
      if(preProject && preProject?.projectId) {
        Object.assign(this.form, {
          projectName: preProject.projectName,
          projectId: String(preProject.projectId),
        })
      }

    },
    createEmailRules() {
      this.$set(this,'rulesMap', {})
      this.$set(this,'systemAutoDetail', {})
      this.$set(this,'customerFields', {})
      this.$set(this,'hideByRuleFields', [])
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for(const i in this.emailRules) { // 规则聚合，方便取值
        const rule = this.emailRules[i]
        this.rulesMap[rule.ruleCode] = rule
      }
      // 开始初始化展示的值
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for(const i in this.emailRules) {
        if(this.emailRules[i].ruleValue.name === RULE_ACTION.SYSTEM){
          this.systemAutoDetail[this.emailRules[i].ruleCode] = this.emailRules[i].ruleValue
        }else if(this.emailRules[i].ruleValue.name === RULE_ACTION.NONE) {
          this.hideByRuleFields.push(this.emailRules[i].ruleCode)
        }else {
          this.customerFields[this.emailRules[i].ruleCode] = this.emailRules[i].ruleValue
        }
      }
      this.initFormData()
    },
    isShowCustomeField(field){
      // 判定自定义字段是在配置内
      const {CUSTOM_FIELDS} = this.orderRules;
      return CUSTOM_FIELDS.fields.includes(field)
    },
    isParentMark(){
      // 子母单标识
      const {PARENT_ORDER_MARK} = this.orderRules;
      return !!PARENT_ORDER_MARK.flag
    },
    tabsChange() {
      // 产品切换部分数据重置
      this.form.isLine = false
      this.form.lineName = ''
      this.form.lineId = ''
      this.form.carTypeName = ''
      this.form.carTypeId = ''
      this.form.mileageKm = ''
      this.form.needPickUp = false
      this.form.needDelivery = false
      this.form.endStation.forEach(e => {
        e.mileageKm = ''
      })
      this.$nextTick(() => {
        this.changeCarType()
      })
      this.getCarType()
    },
    toProject() {
      this.$router.push('/organization')
    },
    handleAfreshVali(prop) {
      this.$refs.orderForm.validateField(prop)
    },
    filterChangeDetil(data) {
      this.changeDetil = data
      this.changeStation()
    },
    changeStation() {
      this.form.mileageKm=null;
      this.$refs.orderForm.clearValidate()
    },
    filterMileage() {
      if (!this.isPretend) {
        return this.filterCode(elementsCode.MILEAGE) && this.form.isLine
      }
      return this.filterCode(elementsCode.MILEAGE)
    },
    closePretend() {
      this.noPretedSelect = false
      this.upLoading = false
    },
    onAddStartStation() {
      this.form.mileageKm=null;
      this.form.pretendStation.push(JSON.parse(JSON.stringify(START_STATION)))
    },
    // 获取合同
    async getContractList() {
      const res = await getContract({
        cargoOwnerCode: this.$store.state.user.customerCode,
        status: 'ENABLED',
        needAllContracts: true,
      })
      this.contractList = res || []
      // 下单页面默认取第一条合同条款
      if (!this.isEditPage && res && res.length > 0 && !this.hideByRuleFields.includes(RULE_FIELD.EMAIL_PRODUCT_CODE)) {
        this.form.contractCode = res[0].contractCode
        this.form.contractName = res[0].contractName
        this.form.contractTermCode = res[0].contractTermInfo[0]?.code
        this.form.contractTermName = res[0].contractTermInfo[0]?.name
        if(!this.systemAutoDetail[RULE_FIELD.EMAIL_PRODUCT_CODE]) {
          if(res[0].partBTenantId) {
            this.$emit("refreshRule", res[0].partBTenantId)
          }
        }
      }
      if (!this.offContract) {
        this.getContractEntry()
      }
    },
    onSearchCarType(text) {
      this.carTypeList = this.allCarTypeList.filter((e) => {
        return e.label.includes(text)
      })
    },
    transtorpChange(value) {
      if (value === this.TransportType.TRUCKLOAD) {
        this.form.needPickUp = false
        this.form.needDelivery = false
      }
    },
    isLineChange(event) {
      this.form.pretendStation = [{START_STATION}];
      if (!event.target.value && this.form.endStation.length <= 0) {
        this.form.endStation = [
          {
            ...END_STATION,
            stationGoodsList: []
          }
        ]
      }
      if (!event.target.value) {
        this.form.lineName = ''
        this.form.lineRemark = ''
        this.form.lineId = ''
      }
    },
    limitDecimals(value) {
      const reg = /^(-)*(\d+)\.(\d\d\d).*$/;
      return `${value}`.replace(reg, '$1$2.$3');
    },
    filterCode(code) {
      const arr = this.productList.map((e) => {
        return e.code
      })
      return arr.includes(code)
    },
    createDisabled() {
      if (this.oneMoreOrder) {
        return false
      }
      return this.form.isLine
    },
    async getContractEntry() {
      // const res = await getContractEntry({
      //   termCodes: this.form.contractTermCode ? [this.form.contractTermCode] : null,
      //   cargoOwnerCode: this.$store.state.user.customerCode
      // })
      // this.productList = res[0]?.elements || []
    },
    replaceContract() {
      if(this.systemAutoDetail[RULE_FIELD.EMAIL_PRODUCT_CODE]) {
        return
      }
      this.$refs.SelectContract.show(null, true)
      // 切换合同要素动态字段清空
      // this.form.mileageKm = ''
      // this.form.carTypeId = ''
      // this.form.carTypeName = ''
      // this.form.transportType = TransportType.BREAK_BULK
      // this.form.isLine = false
      // this.form.lineName = ''
      // this.form.lineRemark = ''
      // this.form.lineId = ''
    },
    async successContract(data) {
      this.selectAll = true;
      if(data.partBTenantId) {
        this.$emit("refreshRule", data.partBTenantId)
      }
      this.form.contractCode = data.contractCode
      this.form.contractName = data.contractName
      this.form.contractTermCode = data.contractTermCode
      this.form.contractTermName = data.contractTermName
      // this.$set(this.form,'projectId','')
      // this.form.endStation.forEach((e) => {
      //   e.mileageKm = ''
      // })
      this.getContractEntry()
      this.getOrganization()
    },
    // filertype() {
    //   console.log('3123123flety', this.carTypeList, this.form.carLength, Object.keys(this.carTypeList)[0])
    //   const data = this.carTypeList[this.form.carLength] ||this.carTypeList[Object.keys(this.carTypeList)[0]]
    //   return data
    // },
    changeCarType() {
      if (this.form.carLength) {
        this.form.carNorms = this.carTypeList[this.form.carLength][0].carSettingName
        this.changeCar()
      }
    },
    changeCar() {
      this.carTypeList[this.form.carLength].forEach((e) => {
        if (e.carSettingName === this.form.carNorms) {
          this.form.carTypeName = e.carSettingName
          this.form.carTypeId = e.id
        }
      })
    },
    onSearchLine(data) {
      this.getCarLine(data)
    },
    async getCarType() {
      const res = await getStandCarType({
        pageSize: '999'
      })
     this.carTypeList = res
     this.initCarType()
    },
    initCarType() {
      const res = this.carTypeList;
      const len = Object.keys(res)
      this.carTypeflag = res.length > 0
      this.carTypeList = res;
      // 初试默认值
      // [this.form.carLength] = len;
      // eslint-disable-next-line prefer-destructuring
      this.form.carLength = len[0]
      // this.form.carNorms = res[len[0]][0].carType
      this.form.carNorms = res[len[0]][0].carSettingName
      this.form.carTypeId = res[len[0]][0].id
      // this.form.carTypeName = `${this.form.carLength}-${res[len[0]][0].carType}`
      this.form.carTypeName = res[len[0]][0].carSettingName
      this.allCarTypeList = this.carTypeList;
    },
    async getStations(data) {
      this.lineTips = false
      const res = await getStations({
        lineId: data.id,
        customerCode: this.$store.state.user.customerCode
      })
      if (!res || res.length <= 0) {
        this.$message.warning('此线路下没有当前货主站点')
        return
      }

      const resdata = []
      const startData = []
      let len = 0
      res.forEach((e) => {
        // 目的地
        if (e.stationType === tationTypeCode.end || e.stationType === tationTypeCode.startEnd) {
          resdata.push(e)
          len += 1
        }
        // 起始地
        if (this.isPretend && e.stationType === tationTypeCode.start || e.stationType === tationTypeCode.startEnd) {
          // 多装多卸不提示起始地目的地相同
          startData.push(e)
        } else if (e.stationType === tationTypeCode.start || e.stationType === tationTypeCode.startEnd && startData.length <= 0) {
          startData.push(e)
          this.lineIipsName = len
          if (e.stationType === tationTypeCode.startEnd) {
            setTimeout(() => {
              this.lineTips = true
            }, 300)
          }
        }
      })
      if (!resdata || resdata.length <= 0) {
        this.$message.warning('该线路没有目的地站点，无法下单')
        return
      }
      if (this.form.isLine) {
        this.form.mileageKm = data.planMile * 1
      }
      // 提前把组件渲染出来，否则数据回填不会显示
      this.form.endStation = resdata.map(() => {
        return {
          ...END_STATION,
          stationGoodsList: []
        }
      })
      this.form.pretendStation = startData.map(() => {
        return {...START_STATION}
      })
      // 起始地目的地数据回填
      this.$nextTick(() => {
        this.$set(this.form, 'endStation', resdata.map(station => ({
          stationId: station.stationId,
          contactName: station.contacts,
          contactPhone: station.telPhone,
          provinceName: station.provinceName,
          cityName: station.cityName,
          countyName: station.countyName,
          address: station.address,
          expectTime: null,
          mileageKm: data.planMile,
          provinceCode: station.provinceCode,
          cityCode: station.cityCode,
          countyCode: station.countyCode,
          stationGoodsList: this.systemAutoDetail[RULE_FIELD.SKU_INFO]?[{...GOODS}]:[]
        })))
        if (this.isPretend) {
          // 多装多卸起始地选择线路回填
          if (startData.length > 0) {
            const arr = startData.map((start) => {
              const {
                stationId,
                stationCode,
                contacts,
                telPhone,
                provinceName,
                cityName,
                countyName,
                address,
                provinceCode,
                cityCode,
                countyCode,
                latitude,
                longitude
              } = start
              return {
                stationId,
                stationCode,
                contactName: contacts,
                contactPhone: telPhone,
                provinceName,
                cityName,
                countyName,
                address,
                expectTime: null,
                provinceCode,
                cityCode,
                countyCode,
                lat: latitude,
                lon: longitude,
                stationFullAddress: `${provinceName}${cityName}${countyName}${address}`
              }
            })
            this.$set(this.form, 'pretendStation', arr)
          } else {
            this.$set(this.form, 'pretendStation', [{...START_STATION}])
          }
        } else if (startData.length > 0) {
          const {
            stationId,
            stationCode,
            contacts,
            telPhone,
            provinceName,
            cityName,
            countyName,
            address,
            provinceCode,
            cityCode,
            countyCode,
            latitude,
            longitude
          } = startData[0]
          this.$set(this.form, 'startStation', {
            stationId,
            stationCode,
            contactName: contacts,
            contactPhone: telPhone,
            provinceName,
            cityName,
            countyName,
            address,
            expectTime: null,
            provinceCode,
            cityCode,
            countyCode,
            lat: latitude,
            lon: longitude
          })
        } else {
          this.$set(this.form, 'startStation', {
            stationId: '',
            contactName: '',
            contactPhone: '',
            expectTime: null,
            provinceName: '',
            cityName: '',
            countyName: '',
            address: '',
            defaultAddress: []
          })
        }
      })
    },
    changeLine(data) {
      this.getStations(data)
      this.form.lineName = data.lineName
      this.form.lineRemark = data.lineCode
    },
    async getCarLine(name = null) {
      const Methode = this.order.ruyeWhite ? getCarLine : getNoRYCarLine;
      const res = await Methode({
        // status: 1,
        // ownerTenantIds: [this.$store.state.user.tenantId],
        // codes: name ? [name] : null,
        // limit: 1000,
        lineStatus: 'ENABLED',
        customerCode: this.$store.state.user.customerCode,
        needStation: true,
        stationStatus: 'ENABLED',
        lineNameLike: name,
        // createTenantId: this.$store.state.user.tenantId
        createTenantId: this.order.ruyeWhite ? null : this.$store.state.user.tenantId
      })
      this.lineList = res.records.map((e) => {
        return {
          ...e,
          label: `${e.lineCode}-${e.lineName}`,
          value: e.id
        }
      })
    },
    onSearchProject(value) {
      this.selectAll = false
      this.projectList = this.projectALLData.filter((e) => {
        return e.label.includes(value)
      })
    },
    checkedList(data) {
      this.form.projectName = data.name
    },
    async getOrganization(value = null) {
      this.fetchOrganization = false
      const accountData = JSON.parse(localStorage.getItem('accountData'))
      const {userId, customerCode} = this.$store.state.user
      const data = {
        accountId: userId,
        relationOrgId: accountData?.id,
        relationType: 'DOWN',
        orgType: 'PROJECT',
        accountType: 'CUSTOMER',
        orgNameLike: value,
        // orgStatus: 'ENABLED',
        status:'ENABLE',
        customerCode,
        source: "OWN",
        // productCode
      }
      const res = await fetchProject(data)
      this.fetchOrganization = true
      if (res && res.length > 0) {
        const normalData=[];
        const disabledData=[];
        const records = res.map(t => ({
          ...t,
          name: t.projectName || t.name,
          code:t.projectCode||t.code
        }))
        records.forEach((e) => {
          let subLabel = ''
          if (e.operationResp?.termName) {
            subLabel = `${e.operationResp.termName}`
          }
          const item= {
            ...e,
            value: `${e.id}`,
            label: e.name,
            subLabel,
            disabled: !e.enableStatus||!this.isSameContractTermCode(e,{contractCode:this.form.contractCode,contractTermCode:this.form.contractTermCode}),
            // disabled:false,
          }
           if(item.disabled){
            disabledData.push(item)
          }else{
            normalData.push(item)
          }
        })
         this.projectList=[...normalData,...disabledData]
      } else {
        this.projectList = []
      }
      if (this.selectAll) {
        this.projectALLData = this.projectList
      }
    },
    orderGoodsTypeChange(value, endStations, endStationIndex) {
      // eslint-disable-next-line no-param-reassign
      endStations.orderGoodsType = value
      if (value === 1) {
        this.form.endStation[endStationIndex].stationGoodsList = [{...GOODS}]
      } else {
        this.form.endStation[endStationIndex].stationGoodsList = []
      }
    },
    closeOrder() {
      this.$router.push('/order/manage')
    },
    async init() {
      // 多装多卸白名单
      // const req = await getConfig({
      //     keys: 'support.multi.loading.customer',
      //     appId: 1002
      // })
      // const list = req.configs[0]?.value.split(',') || ''
      // if(list.includes(this.$store.state.user.customerCode)){
      //     this.isPretend = true
      // }
      this.$emit('changeTabStatus',true)
      this.odrNo = this.$route.query.odrNo
      this.oneMoreOrder = !!this.$route.query.oneMoreOrder
      if (!this.oneMoreOrder) {
        this.isEditPage = !!this.odrNo
      }
      // 再来一单并且是企业视角需要请求授信预警
      if (this.isEnterprise && this.oneMoreOrder) {
        this.$emit('showTips')
      }
      // this.form.contractCode = this.$route.query.contractCode
      // this.form.contractTermCode = this.$route.query.contractTermCode
      // this.form.contractName = this.$route.query.contractName
      // this.form.contractTermName = this.$route.query.contractTermName
      if (this.isEditPage || this.oneMoreOrder) {
        if (!this.isPretend) {
         await this.setDetail()
        } else {
          // 多装多卸编辑
         await this.setPretendDetail()
        }
      }
      this.$emit('changeTabStatus',false)
    },
    async setDetail() {
      //  const params = {
      //     size: 50,
      //     page: 1
      // }
      // 编辑订单判断同组
      // const groupRes = await fetchOrderList({
      //     associationOdrNo: this.odrNo,
      //     createTime__BETWEEN: [this.$route.query.createTime__BETWEEN[0]*1,this.$route.query.createTime__BETWEEN[1]*1],
      //     projectIds: null,
      //     skuName: null,
      //     status: ["0", "2", "3", "4", "5", "100"]
      // }, params)
      // this.sameGroup = groupRes.records.length > 1
      const res = await featchOrderDetailUnify({
        unifyOdrNo: this.odrNo
      })
      await this.getCarLine(res.lineName)
      this.startTime = res.startTime || res.startStation?.startTime;
      const endList = res.endStations
      // const endList = res.endStations.filter((end) => {
      //     return end[0].status !== CANCELED
      // })
      if (res.isLoadingAndUnloadingMuch) {
        this.lineDisbled = true
      }
      this.form = {
        isLoadingAndUnloadingMuch: res.isLoadingAndUnloadingMuch,
        transportType: TransportType[res.orderType],
        ...res.ext,
        odrChannel: res.odrChannel,
        remark: res.remark,
        projectId: res.projectId,
        projectName: res.projectName,
        parentId: this.accountData.id,
        contractCode: res.contractCode,
        contractName: '',
        contractTermCode: res.contractTermCode,
        contractTermName: '',
        isLine: res.isLine,
        lineId: '',
        lineName: res.lineName,
        lineRemark: res.lineRemark,
        carTypeName: res.carTypeName,
        carTypeId: res.carTypeId,
        mileageKm: res.mileageKm,
        needPickUp: res.needPickUp,
        needDelivery: res.needDelivery,
        crmNumber: this.oneMoreOrder ? '' : res.crmNumber,
        orderLabel: res.orderLabel,
        pretendStation: [{...START_STATION}],
        startStation: {
          stationId: res.startStations[0].stationId,
          stationName: res.startStations[0].stationName,
          stationCode: res.startStations[0].stationCode,
          contactName: res.startStations[0].contactName,
          contactPhone: res.startStations[0].contactPhone,
          expectTime: this.oneMoreOrder ? '' : moment(res.startStations[0].startTime),
          expectTimeLeft:[moment(res.startStations[0].startTime).format('HH:mm:ss')],
          provinceName: res.startStations[0].provinceName,
          cityName: res.startStations[0].cityName,
          countyName: res.startStations[0].countryName,
          // provinceCode: res.consignorProvinceCode,
          // cityCode: res.consignorCityCode,
          // countyCode: res.consignorCountyCode,
          address: res.startStations[0].stationAddress
        },
        // endStation: endList.map(station => ({
        //     id: station.id,
        //     stationId: station.stationId,
        //     stationCode: station.stationCode,
        //     contactName: station.contactName,
        //     contactPhone: station.contactPhone,
        //     provinceName: station.provinceName,
        //     cityName: station.cityName,
        //     countyName: station.countryName,
        //     address: station.stationAddress,
        //     expectTime: this.oneMoreOrder ? '' : moment(station.reachTime),
        //     // crmNumber: res.crmNumber,
        //     // provinceCode: station.recipientProvinceCode,
        //     // cityCode: station.recipientCityCode,
        //     // countyCode: station.recipientCountyCode,
        //     orderGoodsType: station.orderGoodsType,
        //     // mileageKm: (res.mileageKm || station.mileageKm) ? res.mileageKm || station.mileageKm : null,
        //     mileageKm: station.mileageKm,
        //     stationGoodsList: station.stationGoodsList.map(goods => {
        //         let flags = false
        //         let tempArr = []
        //         if(goods.temperatureZone.includes('~')){
        //             flags = true
        //             tempArr = goods.temperatureZone.split('~')
        //         }
        //         const { skuId, skuCode, skuName, weight, volume, goodsValue, number, ext, id } = goods
        //         return ({
        //             id,
        //             skuId,
        //             skuCode,
        //             skuName,
        //             weight,
        //             volume,
        //             skuUnit: ext?.goodsUnit,
        //             goodsValue,
        //             number,
        //             skuNorms: `${goods.skuNorms}/${ext?.goodsUnit}`,
        //             temperatureZone: flags ? '自定义温区' : goods.temperatureZone,
        //             lowtemp: flags ? tempArr[0] * 1 : '',
        //             hightemp: flags ? tempArr[1] * 1 : '',
        //         })
        //     })
        // })),
        endStation: endList.map(station => {
          const goodsList = []
          station.forEach((goodsItem) => {
            goodsList.push(...goodsItem.stationGoodsList)
          })
          return ({
            id: station.id,
            stationId: station[0].stationId,
            stationName: station[0].stationName,
            stationCode: station[0].stationCode,
            contactName: station[0].contactName,
            contactPhone: station[0].contactPhone,
            provinceName: station[0].provinceName,
            cityName: station[0].cityName,
            countyName: station[0].countryName,
            address: station[0].stationAddress,
            expectTime: this.oneMoreOrder ? '' : moment(station[0].reachTime),
            expectTimeLeft:[moment(station[0].reachTime).format('HH:mm:ss')],
            // crmNumber: res.crmNumber,
            // mileageKm: res.mileageKm ? res.mileageKm : null,
            mileageKm: station[0].mileageKm,
            provinceCode: station[0].provinceCode,
            cityCode: station[0].cityCode,
            countyCode: station[0].countryCode,
            orderGoodsType: station[0].orderGoodsType,
            lat: station[0].latitude,
            lon: station[0].longitude,
            stationGoodsList: goodsList.map(goods => {
              let flags = false
              if (goods.temperatureZone && goods.temperatureZone.includes('~')) {
                flags = true
              }
              const {skuId, skuCode, skuName, weight, volume, goodsValue, number, ext, id, startStationId} = goods
              const startAddress = res.startStations.filter((str) => {
                return str.stationId === startStationId
              })
              return ({
                id,
                skuId,
                skuCode,
                skuName,
                weight,
                volume,
                skuUnit: ext?.goodsUnit,
                goodsValue,
                number,
                // skuNorms: `${goods.skuNorms}/${ext?.goodsUnit}`,
                skuNorms: goods.skuNorms,
                temperatureZone: flags ? '自定义温区' : goods.temperatureZone,
                hightemp: flags ? Number(goods.temperatureZone.split('~')[1] || 0) : '',
                lowtemp: flags ? Number(goods.temperatureZone.split('~')[0] || 0) : '',
                shipment: startAddress[0]?.stationAddress
              })
            })
          })
        })
      }
       this.nextTick(res)
      if (!this.offContract) {
        // 合同条款名称回显
        const resContract = await getContract({
          cargoOwnerCode: this.$store.state.user.customerCode,
          status: 'ENABLED',
          needAllContracts: true,
        })
        resContract.forEach((e) => {
          if (e.contractCode === this.form.contractCode) {
            this.form.contractName = e.contractName
            e.contractTermInfo.forEach((n) => {
              if (n.code === this.form.contractTermCode) {
                this.form.contractTermName = n.name
              }
            })
          }
        })
      }
    },
     nextTick(res) {
      this.$nextTick(async() => {
        this.form.lineId = res.lineId
        this.form.contractTermCode = res.contractTermCode
        this.getOrganization()
        if (!this.offContract) {
          await this.getContractEntry()
        }
        if (this.oneMoreOrder) {
          // 车型不存在时且为可选车型时 默认选中第一个
          if (this.carTypeList.length > 0 && this.carTypeList.filter((e) => {
            return e.id === this.form.carTypeId
          }).length <= 0) {
            // this.getCarType();
            this.form.carTypeName = this.carTypeList[0].carSettingName
            this.form.carTypeId = this.carTypeList[0].id
          }else{
            // 兼容异步车型回填问题
            // this.form.carTypeName = undefined;
            // this.form.carTypeId = undefined;
          }
          // 所选线路不存在时
          // if (this.lineList.filter((e) => { // 根据规则下单配置需求注释，因为不需要一定存在，可以填入线路标识
          //   return e.id === this.form.lineId
          // }).length <= 0) {
          //   this.form.lineId = ''
          //   this.form.isLine = false
          //   this.form.lineName = ''
          //   this.form.lineRemark = ''
          // }
        }
        // 再来一单时项目不存在，默认选中第一条
        if (this.projectList.filter((e) => {
          return e.value === this.form.projectId
        }).length <= 0) {
          if (this.oneMoreOrder && !this.systemAutoDetail[RULE_FIELD.EMAIL_PROJECT_CONDITION] && !this.hideByRuleFields.includes(RULE_FIELD.EMAIL_PROJECT_CONDITION)) {
            this.form.projectId = this.projectList[0]?.value || ''
            this.form.projectName = this.projectList[0]?.label || ''
          } else {
            this.form.projectId = ''
            this.form.projectName = ''
          }
        }
      })
    },
    async setPretendDetail() {
      // 多装多卸编辑数据处理
      const res = await featchOrderDetailUnify({
        unifyOdrNo: this.odrNo
      })
      await this.getCarLine(res.lineName)
      let cartext = res.carTypeName ? parseFloat(res.carTypeName) : ''
      cartext = cartext ? cartext.toFixed(2) : res.carTypeName
      // 已取消目的地过滤
      const endList = []
      const starAddrList = []
      res.endStations.forEach((e) => {
        const arr = []
        e.forEach((item) => {
          if (this.oneMoreOrder) {
            arr.push(item)
            item.stationGoodsList.forEach((goods) => {
              if (!starAddrList.includes(goods.startStationId)) {
                starAddrList.push(goods.startStationId)
              }
            })
          } else if (item.status !== CANCELED) {
            arr.push(item)
            item.stationGoodsList.forEach((goods) => {
              if (!starAddrList.includes(goods.startStationId)) {
                starAddrList.push(goods.startStationId)
              }
            })
          }
        })
        if (arr.length > 0) {
          endList.push(arr)
        }
      })
      // 已取消 未被选择的起始地
      const startList = [];
      res.startStations.forEach((e) => {
        if (starAddrList.includes(e.stationId)) {
          startList.push(e)
          this.startNum.push(e.stationAddress)
        }
      })

      // const endList = res.endStations.filter((end) => {
      //     return end.status !== CANCELED
      // })
      this.lineDisbled = true
      this.$set(this,'form', {
        isLoadingAndUnloadingMuch: res.isLoadingAndUnloadingMuch,
        transportType: TransportType[res.orderType],
        ...res.ext,
        odrChannelCode: res.odrChannel,
        odrChannel: res.odrChannel,
        remark: res.remark,
        projectId: res.projectId,
        orderLabel: res.orderLabel,
        projectName: res.projectName,
        parentId: this.accountData.id,
        contractCode: res.contractCode,
        contractName: '',
        contractTermCode: res.contractTermCode,
        contractTermName: '',
        isLine: res.isLine,
        carTypeName:res.carTypeName,
        carLength:cartext,
        carNorms:res.carTypeName,
        carTypeId:res.carTypeId,
        lineId: '',
        lineName: res.lineName,
        lineRemark: res.lineRemark,
        mileageKm: res.mileageKm,
        needPickUp: res.needPickUp,
        needDelivery: res.needDelivery,
        crmNumber: this.oneMoreOrder ? '' : res.crmNumber,
        startStation: {
          stationId: '',
          contactName: '',
          contactPhone: '',
          expectTime: null,
          provinceName: '',
          cityName: '',
          countyName: '',
          address: '',
          defaultAddress: []
        },
        pretendStation: startList.map((startStations) => {
          return {
            stationId: startStations.stationId,
            stationName: startStations.stationName,
            stationCode: startStations.stationCode,
            contactName: startStations.contactName,
            contactPhone: startStations.contactPhone,
            expectTime: this.oneMoreOrder ? '' : moment(startStations.startTime),
            expectTimeLeft:[moment(startStations.startTime).format('HH:mm:ss')],
            provinceName: startStations.provinceName,
            cityName: startStations.cityName,
            countyName: startStations.countryName,
            provinceCode: startStations.provinceCode,
            cityCode: startStations.cityCode,
            countyCode: startStations.countryCode,
            address: startStations.stationAddress,
            lat: startStations.latitude,
            lon: startStations.longitude
          }
        }),
        endStation: endList.map(station => {
          const goodsList = []
          station.forEach((goodsItem) => {
            // 过滤已取消的订单货品
            // if(goodsItem.status !== CANCELED){
            goodsList.push(...goodsItem.stationGoodsList)
            // }
          })
          return ({
            id: station.id,
            stationId: station[0].stationId,
            stationName: station[0].stationName,
            stationCode: station[0].stationCode,
            contactName: station[0].contactName,
            contactPhone: station[0].contactPhone,
            provinceName: station[0].provinceName,
            cityName: station[0].cityName,
            countyName: station[0].countryName,
            address: station[0].stationAddress,
            expectTime: this.oneMoreOrder ? '' : moment(station[0].reachTime),
            expectTimeLeft:[moment(station[0].reachTime).format('HH:mm:ss')],
            // crmNumber: res.crmNumber,
            // mileageKm: res.mileageKm ? res.mileageKm : null,
            mileageKm: station[0].mileageKm,
            provinceCode: station[0].provinceCode,
            cityCode: station[0].cityCode,
            countyCode: station[0].countryCode,
            orderGoodsType: station[0].orderGoodsType,
            lat: station[0].latitude,
            lon: station[0].longitude,
            stationGoodsList: goodsList.map(goods => {
              let flags = false
              if (goods.temperatureZone && goods.temperatureZone.includes('~')) {
                flags = true
              }
              const {
                skuId,
                skuCode,
                skuName,
                weight,
                volume,
                goodsValue,
                number,
                ext,
                id,
                startStationId,
                odrNo
              } = goods
              const startAddress = res.startStations.filter((str) => {
                return str.stationId === startStationId
              })
              return ({
                id,
                skuId,
                skuCode,
                skuName,
                weight,
                volume,
                skuUnit: ext?.goodsUnit,
                goodsValue,
                number,
                // skuNorms: `${goods.skuNorms}/${ext?.goodsUnit}`,
                skuNorms: goods.skuNorms,
                temperatureZone: flags ? '自定义温区' : goods.temperatureZone,
                hightemp: flags ? Number(goods.temperatureZone.split('~')[1] || 0) : '',
                lowtemp: flags ? Number(goods.temperatureZone.split('~')[0] || 0) : '',
                shipment: startAddress[0]?.stationAddress,
                startStationAddress: startAddress[0]?.fullAddress,
                orderNo: odrNo,
                goodsLevel: goods.goodsLevel1 ? [goods.goodsLevel1, goods.goodsLevel2, goods.goodsLevel3] : []
              })
            })
          })
        })
      })
      if(res.carTypeId) {
        this.$set(this,'form', {...this.form,...{ carTypeName:res.carTypeName,
            carLength:cartext,
            carNorms:res.carTypeName,
            carTypeId:res.carTypeId,}})
      }else {
        this.initCarType()
      }
        this.nextTick(res)
      if (!this.offContract) {
        // 合同条款名称回显
        const resContract = await getContract({
          cargoOwnerCode: this.$store.state.user.customerCode,
          status: 'ENABLED',
          needAllContracts: true,
        })
        resContract.forEach((e) => {
          if (e.contractCode === this.form.contractCode) {
            this.form.contractName = e.contractName
            e.contractTermInfo.forEach((n) => {
              if (n.code === this.form.contractTermCode) {
                this.form.contractTermName = n.name
              }
            })
          }
        })
      }
    },
    async onSubmit() {
      this.upLoading = true
      if (this.form.isLine === true && this.form.lineId === '') {
        this.$message.warning('请选择线路')
        this.upLoading = false
        return
      }
      const {expectTime} = this.form.startStation || {}
      // 编辑情况下需要校验提货时间不能早于当前时间
      // if (this.isEditPage && expectTime && moment(expectTime).valueOf() < moment().valueOf() - 600000) {
      //     this.$message.error('提货时间不得早于当前时间')
      //     this.upLoading = false
      //     return
      // }
      // 编辑时需要检验起始地提货时间不允许早于初始提货时间
      // if(this.isEditPage && expectTime && this.startTime > moment(expectTime).valueOf()) {
      //     this.$message.error('提货时间不允许早于初始提货时间')
      //     this.upLoading = false
      //     return
      // }
      const {endStation} = this.form;
      if (expectTime) {
        let checkTime = false;
        endStation.forEach(item => {
          if (item.expectTime && new Date(item.expectTime) <= new Date(expectTime)) {
            checkTime = true
          }
        })
        if (checkTime) {
          this.$message.error('送达时间不能小于等于取货时间');
          this.upLoading = false;
          return
        }
      }
      try {
        await this.$refs.orderForm.validate()
        if(this.isOrderDemoVersion){
          // 当前货主属于在"货主端仓下单演示版本名单"内,在提交前弹窗选择结算方式
          await this.$refs.settlementModes.show()
        }
        await this.submitOrder()
      } catch {
        this.upLoading = false
        this.errorScroll()
      }
    },
    errorScroll() {
      // // if (errDomList[0]) {
      // //   // errDomList[0].scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
      // //   console.log( document.getElementById("popContainer"))
      // //   document.querySelector("#popContainer").scrollTo(0, 30);
      // //
      // // }
      this.$nextTick(()=>{
        scrollToTarget('.has-error')
      })



    },
    successMessage() {
      this.$message.success(`订单${this.isEditPage ? '编辑' : '创建'}成功`)
      this.$route.meta.canRefresh = true
      setTimeout(() => {
        this.$router.push('/order/manage')
        this.upLoading = false
      }, 1000)
    },
    clearParamsByRule(params){ // 根据规则删除系统填充和不需填写的字段
      if(this.systemAutoDetail[RULE_FIELD.EMAIL_PRODUCT_CODE] || this.hideByRuleFields.includes(RULE_FIELD.EMAIL_PRODUCT_CODE)) {
        delete params?.contractCode
        delete params?.contractName
        delete params?.contractTermCode
        delete params?.contractTermName
      }
      if(!this.isEditPage && this.systemAutoDetail[RULE_FIELD.EMAIL_PROJECT_CONDITION] || this.hideByRuleFields.includes(RULE_FIELD.EMAIL_PROJECT_CONDITION)) {
        delete params?.projectId
        delete params?.projectName
      }
      if(this.systemAutoDetail[RULE_FIELD.EMAIL_CAR_TYPE] || this.hideByRuleFields.includes(RULE_FIELD.EMAIL_CAR_TYPE)) {
        delete params?.carLength
        delete  params?.carTypeId
        delete  params?.carTypeName
        delete  params?.carNorms
      }
      if(this.systemAutoDetail[RULE_FIELD.EMAIL_LINE_REMARK] || this.hideByRuleFields.includes(RULE_FIELD.EMAIL_LINE_REMARK)) {
        delete params?.isLine
        delete  params?.lineName
        delete  params?.lineId
        delete  params?.lineRemark
      }

    },
    async submitOrder() {
      if (this.isPretend) {
        // 多装多卸 校验起始地是不是都被选中的
        const arr = this.form.pretendStation.map((e) => {
          return {
            ...e,
            isSelect: false,
          }
        })
        let canSubmit = true
        this.form.endStation.forEach((e) => {
          e.stationGoodsList.forEach((goods) => {
            if (e.orderGoodsType === 1 && !Number(goods.volume, 10) && !Number(goods.weight, 10)) {
              canSubmit = false
            }
            arr.forEach((item, index) => {
              if (item.address === goods.shipment) {
                arr[index].isSelect = true
              }
            })
          })
        })
        if (!canSubmit &&!this.systemAutoDetail[RULE_FIELD.SKU_INFO]) {
          this.$message.error('请填写货品品类重量或者体积')
          this.upLoading = false
          return
        }
        // 未被选择的起始地
        const noSelect = arr.filter((e) => {
          return !e.isSelect
        })
        // 起始地个数大于1 且有未选中的
        if (this.form.pretendStation.length > 1 && noSelect && noSelect.length > 0) {

          this.noSelect = noSelect
          this.noPretedSelect = true
        } else {
          this.noSelect = []
          this.submitPretend()
        }
      } else {
        const params = this.buildParams()
        if (this.isEditPage) {
          await updateOrder({
            ...params,
            // mileageKm: params.endStationList[0].mileageKm || 0,
            unifyOdrNo: this.odrNo
          })
          this.successMessage()
          return
        }
        params.odrChannel = odrChannel
        await createOrderByRule(params)
        this.successMessage()
      }
    },
    async submitPretend() {
      const preList = JSON.parse(JSON.stringify(this.form.pretendStation))
      const noSelectList = this.noSelect.map((e) => {
        return e.address
      })
      this.form.pretendStation = preList.filter((item) => {
        return !noSelectList.includes(item.address)
      })
      this.noPretedSelect = false
      // 多装多卸下单和编辑
      const params = this.pretendParams()
      params.odrChannel = odrChannel
      try {
        this.clearParamsByRule(params)
      }catch (e) {
        console.log(e);
      }
      try {
        if (this.isEditPage) {
          await updateStandardEditUnify({
            ...params,
            unifyOrderNo: this.odrNo
          })
          this.successMessage()
          return
        }
        await createOrderByRule(params)
        this.successMessage()
      } catch {
        this.upLoading = false
      }
    },
    pretendParams() {
      // 多装多卸提交数据处理
      const {endStation, startStation, pretendStation,crmNumber,mileageKm,needDelivery,needPickUp, ...otherParams} = this.form
      const {productType, projectId, projectName} = this.form
      const endStationList = []
      const startStationList = []
      const customeField =this.setCustomeFields({crmNumber,mileageKm,needDelivery,needPickUp})
      endStation.forEach(item => {
        const {stationGoodsList, ...otherEndStation} = item
        endStationList.push({
          ...otherEndStation,
          stationContact: item.contactName,
          stationContactPhone: item.contactPhone,
          stationAddress: item.address,
          goodsList: stationGoodsList.map(goods => {
            let startStationAddress = ''
            if (pretendStation.length > 1) {
              startStationAddress = goods.startStationAddress
            } else {
              const {address, cityName, countyName, provinceName} = pretendStation[0]
              startStationAddress = `${provinceName}${cityName}${countyName}${address}`
            }
            if(this.systemAutoDetail[RULE_FIELD.SKU_INFO]){
              const ruleGoods = this.systemAutoDetail[RULE_FIELD.SKU_INFO]
              return {
                ...goods,
                temperatureZone: ruleGoods.temp,
                planAmount: ruleGoods.totalSum,
                planWeight: ruleGoods.totalWeight,
                planVolume: ruleGoods.totalVol,
                startStationAddress,
              }
            }
            return {
              ...goods,
              temperatureZone: goods.temperatureZone === '自定义温区' ? `${goods.lowtemp || ''}~${goods.hightemp || ''}` : goods.temperatureZone,
              skuUnit: goods.skuUnit || '件',
              planAmount: goods.number,
              planWeight: goods.weight,
              planVolume: goods.volume,
              skuValue: goods.goodsValue,
              startStationAddress,
            }
          }),
          endTime: moment(otherEndStation.expectTime).valueOf()
        })
      });

      pretendStation.forEach((item) => {
        startStationList.push({
          ...item,
          stationContact: item.contactName,
          stationContactPhone: item.contactPhone,
          stationAddress: item.address,
          startTime: moment(item.expectTime).valueOf()
        })
      })

      return {
        ...otherParams,
        ...customeField,
        lineId: otherParams.isLine ? otherParams.lineId : '',
        productType,
        projectId,
        projectName,
        startStations: startStationList,
        endStations: endStationList,
        scene: 'TRANSPORT_ONLY'
      }
    },
    setCustomeFields(data){
      const params = {}
      Object.keys(data).forEach(item=>{
        if(this.isShowCustomeField(ORDER_CUSTOME_FIELDS[item])){
          params[item] = data[item]
        }
      })
      return params
    },
    buildParams() {
      const {endStation, startStation, crmNumber, mileageKm, needDelivery, needPickUp, ...otherParams} = this.form
      const endStationList = []
      const goodsList = []
      const customeField =this.setCustomeFields({crmNumber,mileageKm,needDelivery,needPickUp})
      endStation.forEach(item => {
        const {stationGoodsList, ...otherEndStation} = item
        const {provinceName, cityName, countyName, address} = otherEndStation
        const stationFullAddress = `${provinceName}${cityName}${countyName}${address}`

        endStationList.push({
          ...otherEndStation,
          expectTime: moment(otherEndStation.expectTime).valueOf()
        })

        stationGoodsList.forEach(goods => {
          goodsList.push({
            ...goods,
            temperatureZone: goods.lowtemp ? `${goods.lowtemp}~${goods.hightemp}` : goods.temperatureZone,
            skuUnit: goods.skuUnit || '件',
            stationFullAddress,
          })
        })
      });
      return {
        ...otherParams,
        ...customeField,
        lineId: otherParams.isLine ? otherParams.lineId : '',
        startStation: {
          ...startStation,
          expectTime: moment(startStation.expectTime).valueOf()
        },
        endStationList,
        endStation: endStationList[0],
        stationGoodsList: goodsList
      }
    },
    // 添加货品
    onAddGoods(goodsList) {
      goodsList.push({...GOODS})
    },
    // 删除货品
    onDeleteGoods(goodsList, index) {
      goodsList.splice(index, 1)
    },
    // 批量添加
    batchAddEndStation() {
      this.batchAddType = StationTypes.RECEIVING
      this.$refs.selectAddressDialog.show({}, true)
    },
    batchAddStartStation() {
      this.batchAddType = StationTypes.SHIPPING
      this.$refs.selectAddressDialog.show({}, true)
    },
    handleAdressFromSelectorChange(stations) {
      // 多装多卸不予许选择相同起点或终点
      const limitTypeStations = this.batchAddType === StationTypes.RECEIVING?this.form.endStation:this.form.pretendStation
      if(this.isPretend){
        if(limitTypeStations.some(e=>stations.find(item=>e.provinceCode === item.provinceCode && e.cityCode === item.cityCode && e.countyCode === item.countyCode && e.address === item.address))){
          this.$message.warning(this.batchAddType === StationTypes.RECEIVING?'收货地信息不能重复':'发货地信息不能重复!')
          return
        }
      }
      const pushStations = stations.map(station=>{
        const {
          contacts, telPhone,
          provinceName, cityName, countyName, address,
          provinceCode, cityCode, countyCode, sourceStationId
        } = station;
        const infos = {
          contactPhone: telPhone,
          contactName: contacts,
          province: provinceName,
          city: cityName,
          county: countyName,
          provinceName,
          cityName,
          countyName,
          address,
          provinceCode,
          cityCode,
          countyCode,
          stationId: sourceStationId
        }
        const {province, city, county} = infos
        const pushData = {
          ...infos,
          stationFullAddress: `${province || ''}${city || ''}${county || ''}${address || ''}`,
          provinceName: province,
          cityName: city,
          countyName: county,
          address
        }
        if(this.batchAddType === StationTypes.RECEIVING) {
          pushData.stationGoodsList= [{...GOODS}];
        }
        return pushData
      })
      if(this.batchAddType === StationTypes.RECEIVING) {
        this.form.endStation = this.form.endStation.concat(pushStations)
      }else {
        const arrs = this.form.pretendStation.concat(pushStations)
        this.$set(this.form,'pretendStation', arrs)
      }
    },
    // 添加目的地
    onAddEndStation() {
      this.form.mileageKm=null;
      this.form.endStation.push({
        ...END_STATION,
        stationGoodsList: [{...GOODS}]
      })
    },
    // 删除目的地
    onDeleteEndStation(index, end) {
      this.form.mileageKm=null;
      this.form.endStation.splice(index, 1)
      if (end.address === this.form.startStation.address) {
        this.lineTips = false
      }
    },
    // 删除起始地
    onDeleteStartStation(index) {
      this.form.mileageKm=null;
      this.form.pretendStation.splice(index, 1)
    },
  },
}
</script>

<style lang="less" scoped>
.OrderManageCreate-root {
  padding-bottom: 50px;

  .margin-left {
    margin-left: 10px;
  }

  .contrat-container {
    background: #F2FBF8;
    border-radius: 6px;
    border: 1px solid #E7E9EC;
    padding: 12px 24px;
    margin-bottom: 12px;

    img {
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }

    .replaceContract {
      color: #06B880;
      margin-left: 20px;
      text-decoration: underline;

      &:hover {
        cursor: pointer;
      }
    }

    .contractTitleName {
      font-weight: 500;
      margin-left: 12px;
      font-size: 16px;
    }
  }

  .other-info {
    /deep/ .ant-col-md-6 {
      float: none;
      display: inline-block;
    }
  }

  .block-container {
    background: #FFFFFF;
    border-radius: 6px;
    padding: 32px 0px;
    margin-bottom: 24px;

    > div:not(:first-of-type) {
      margin-top: 50px;
    }

    .title {
      margin-bottom: 25px;
    }

    .origin-station {
      /deep/ .icon {
        background: #06B880;
      }

      .deleteStyle {
        margin: 0 24px;
        color: #F56C6C;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .destination {
      /deep/ .icon {
        background: #FB9432;
      }

      .deleteStyle {
        margin: 0 24px;
        color: #F56C6C;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .station-add {
    background: #F2FBF8;
    border: 1px dashed #06B880;
    line-height: 48px;
    flex-grow: 1;
    //margin-bottom: 40px;

    &:hover {
      background: #029869;
      border: 1px dashed #029869;
      transition: all 1s;

      .ant-btn {
        color: #FFFFFF;
      }
    }
  }

  .order-radio {
    .ant-radio-wrapper {
      margin-right: 23px;
      border-radius: 4px;
      border: 1px solid #E7E9EC;
      height: 32px;
      line-height: 32px;
      padding: 0px 13px 0px 9px;

      &.ant-radio-wrapper-checked {
        border: 1px solid #06B880;
      }

      &:hover {
        border: 1px solid #06B880;
      }
    }
  }
}

.odr-txt {
  position: absolute;
  top: -50px;
  right: 30px;
  z-index: 1;
  color: #666;
}

.align-right {
  margin-left: -30px;
  text-align: right;
  height: 50px;
  // background-color: #f0f2f5;
  background-color: #ffffff;
  box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
  padding-top: 10px;
  box-sizing: border-box;
  padding-right: 30px;
  box-sizing: border-box;

  .close {
    margin-right: 30px;
  }
}

.remark-input {
  width: 500px;
}

/deep/ .ant-space-vertical {
  width: 100%;
}

.radioStyle {
  color: #06b880;
}

/deep/ .ant-calendar-picker {
  // max-width: 302px !important;
  width: 100%;
}

.porject-label {
  background: #fff;
  padding: 16px 24px 24px 24px;

  .projectTitle {
    display: flex;
    align-items: center;

    .item-line {
      width: 4px;
      height: 18px;
      background: #06B880;
      border-radius: 2px;
      margin-right: 10px;
    }

    .subtitle {
      font-weight: bold;
      font-size: 16px;
    }
  }

  .content {
    width: 100%;
    height: 40px;
  }
}

.radioBox {
  padding-left: 40px;
  margin-top: 15px;
}

.siteBox {
  display: inline-block;
  width: 400px;
  margin: 0 20px 0 0;
}

/deep/ .orderNumStyle {
  max-width: 302px !important;
  width: 100%;
}
/deep/ .ant-form-item-label {
  font-weight: 600;
}

.specialCarTips {
  width: 100%;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  background: #FFFBE6;
  border-radius: 6px;
  padding: 0 17px;
  border: 1px solid rgba(255, 229, 143, 0.5);

  .anticon-exclamation-circle {
    color: #FAAD14;
  }

  .anticon-close {
    float: right;
    margin-top: 13px;

    &:hover {
      cursor: pointer;
    }
  }
}

.noPreteStyle {
  color: red;
}

.carrier_cut {
  display: flex;

  .carrier {
    flex: 1;
    display: flex;
    align-self: center;
    border-right: 1px solid #DCDEE0;
    margin-right: 20px;

    img {
      width: 24px;
      height: 24px;
    }
  }

  .projectTitle {
    flex: 1;
  }

  .carrier_content {
    display: flex;
    align-items: center;
  }
}
.car-specifications {
  margin: 0;
  text-align: center;
  color: #171717;

  > span {
    font-weight: 500;
    margin-right: 12px;
  }

  .specifications-radio {
    background: #F4F5F6;
    border-radius: 4px;
    height: 48px;
    line-height: 48px;
    padding: 0 6px;

    /deep/ .ant-radio-wrapper {
      color: #A9ABAE;
      margin: 0;
      line-height: 32px;
      padding: 0 12px;
      margin: 8px;

      .ant-radio-inner {
        display: none;
      }

      &:hover {
        color: #06B880;
      }

      &:active {
        color: #029869;;
      }

      &.ant-radio-wrapper-checked {
        background: #06B880;
        border-radius: 4px;
        color: #FFFFFF;
      }

      span.ant-radio + * {
        padding: 0;
      }
    }
  }
}
.CarType {
  margin: 20px 0;
}
.station-add-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  .add-wrapper-batch {
    width: 145px;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #000000;
    .icon-batch-address {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
}
.block-container {
  padding: 16px!important;
}
.zimu_table{
  margin-right: 4px;
}
</style>
